import React, { Key } from "react";
import { NavLink } from "react-router-dom";

function IconsProps(props: any) {
  const { data } = props;
  return (
    <div className="icons-props-container">
      {data.map(
        (
          item: {
            image: any | undefined;
            link: string;
            alt: string;
            number: string;
          },
          index: Key
        ) => {
          return (
            <div className="icons-props" key={index}>
              <NavLink to={item.link} target="_blank">
                <button className="icons-button">
                  {item.image}
                  <p>{item.number}</p>
                </button>
              </NavLink>
            </div>
          );
        }
      )}
    </div>
  );
}

export default IconsProps;
